import { render, staticRenderFns } from "./TelegramInstallPromotion.vue?vue&type=template&id=00c6d033&scoped=true&"
import script from "./TelegramInstallPromotion.vue?vue&type=script&lang=js&"
export * from "./TelegramInstallPromotion.vue?vue&type=script&lang=js&"
import style0 from "./TelegramInstallPromotion.vue?vue&type=style&index=0&id=00c6d033&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c6d033",
  null
  
)

export default component.exports